// extracted by mini-css-extract-plugin
module.exports = {"progress-label":"progress-label__YnIe6"};